/* Original Canada Commerce Group catalog interactions. No purchasing requests. */
document.addEventListener('DOMContentLoaded', () => {
  for (const select of document.querySelectorAll('[data-quote-variant]')) {
    const update = () => {
      const option = select.selectedOptions[0];
      const form = select.closest('form');
      if (!option || !form) return;
      const sku = form.querySelector('[data-quote-sku]');
      const variantId = form.querySelector('[data-quote-variant-id]');
      if (sku) sku.value = option.dataset.sku || '';
      if (variantId) variantId.value = option.dataset.variantId || '';
    };
    select.addEventListener('change', update);
    update();
  }
  const filters = document.querySelector('[data-solar-filters]');
  if (filters) {
    const cards = [...document.querySelectorAll('[data-solar-card]')];
    const search = filters.querySelector('[data-solar-search]');
    const technology = filters.querySelector('[data-solar-technology]');
    const apply = () => {
      const query = search.value.trim().toLowerCase();
      let shown = 0;
      for (const card of cards) {
        const match = (!query || card.textContent.toLowerCase().includes(query)) && (!technology.value || card.dataset.technology === technology.value);
        card.hidden = !match;
        if (match) shown++;
      }
      const count = document.querySelector('[data-solar-count]');
      if (count) count.textContent = String(shown);
      const empty = document.querySelector('[data-solar-empty]');
      if (empty) empty.hidden = shown !== 0;
    };
    search.addEventListener('input', apply);
    technology.addEventListener('change', apply);
    filters.addEventListener('reset', () => requestAnimationFrame(apply));
  }
  const params = new URLSearchParams(location.search);
  const fill = (selector, value) => {
    const input = document.querySelector(selector);
    if (input && value) input.value = value.slice(0, 400);
  };
  fill('[data-general-product]', params.get('product'));
  fill('[data-general-sku]', params.get('sku'));
  fill('[data-general-variant]', params.get('variant'));
  // Close an open navigation menu when focus or pointer moves elsewhere.
  for (const menu of document.querySelectorAll('.nav-menu, .mobile-nav')) {
    document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
    menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
  }
});
